// The loaded city, published for render systems that need to READ it (street
// lights, the road map, the radar) without being children of CityModel.
// Mutated in place; `version` bumps when a new city arrives.
export const cityBridge = {
  model: null,      // the fitted city root (Object3D)
  batches: null,    // BatchedMesh[] drawing it
  bounds: null,     // { min:[x,z], max:[x,z] } world footprint
  version: 0,
};

export function publishCity(model, batches, bounds) {
  cityBridge.model = model;
  cityBridge.batches = batches;
  cityBridge.bounds = bounds;
  cityBridge.version += 1;
}

export function clearCity(model) {
  if (cityBridge.model !== model) return;
  cityBridge.model = null;
  cityBridge.batches = null;
  cityBridge.version += 1;
}
